import { PermissionName } from '@sironamedical/common/constants/permissionName';
import { useCurrentUser } from 'hooks/useCurrentUser';
import { useValidateUserHasRbacPermissions } from 'hooks/useValidateUserHasRbacPermissions';
import { WithApolloContext } from 'modules/Apollo/types';

export const useHasQualityControlPermission = ({ context }: WithApolloContext): boolean => {
  const { data } = useCurrentUser({ context });

  const permission = useValidateUserHasRbacPermissions({
    permissionNames: [PermissionName.WorklistQualityControlWorkflow],
  });

  return data ? permission : false;
};
